import { Button, Input } from "antd";
import { locale, t } from "../MainApp";
import React from "react";
import { IMember } from "../App";
import { ESearchMode, GuestPersonAutocomplete } from "../sharedcomponents/GuestPersonAutocomplete";

type GuestsListProps = {
    namesOfTheGuests: string[];
    isTheMemberGuest: boolean;
    isTheChildGuest: boolean;
    member: IMember;

    onChangeGuestName: (index: number, name: string) => void;

    onAddGuest: () => void;
    onRemoveGuest: (index: number) => void;
    onCanAddSingleGuest: () => boolean;

    onAddMemberToGuestList: (swapChild: boolean) => void;
    onRemoveMemberFromGuestList: () => void;

    onRemoveChildFromGuestList: () => void;
    onAddChildToGuestList: (swapParent: boolean) => void;

    onBuildFullCapacityMessage: () => string;

    locale: locale;
};

export function GuestsList(props: GuestsListProps) {

    function printNamesOfTheGuests() {
        return props.namesOfTheGuests.map((value: string, index: number) => {
            let placeholder: string = t(props.locale, 'nameOfGuest') + (index + 1).toString();

            let protectedIndexes: number[] = [0];
            if (props.isTheMemberGuest && props.isTheChildGuest) {
                protectedIndexes.push(1);
            }

            if (protectedIndexes.includes(index)) {
                return (<Input placeholder={placeholder} value={value} readOnly={true} />);
            } else {
                return (
                    <React.Fragment>
                        <GuestPersonAutocomplete
                            onChangeGuestName={(newName) => props.onChangeGuestName(index, newName)}
                            value={value}
                            style={{ width: '66%' }}
                            onBuildGuestName={() => placeholder}
                            searchMode={ESearchMode.SingleHallReservation}
                        />
                        <Button onClick={() => props.onRemoveGuest(index)} style={{ width: '33%' }}>{t(props.locale, "labelremoveguest")}</Button>
                    </React.Fragment>
                );
            }
        });
    }

    return (
        <>
            { props.member.hasChild 
                ? 
                  <React.Fragment> 
                    { props.isTheMemberGuest
                      ? props.isTheChildGuest ? <Button style={{ width: '100%', marginBottom: '0.25rem' }} type="primary" onClick={() => props.onRemoveMemberFromGuestList()}>{t(props.locale, "removemember")}</Button> : ''
                      : <Button style={{ width: '100%', marginBottom: '0.25rem' }} type="primary" onClick={() => props.onAddMemberToGuestList(!props.onCanAddSingleGuest())}>{props.onCanAddSingleGuest() ? t(props.locale, "addmember") : t(props.locale, "swapchildtoparent")}</Button>                       
                    }                    
                    { props.isTheChildGuest 
                      ? props.isTheMemberGuest ? <Button style={{ width: '100%', marginBottom: '0.25rem' }} type="primary" onClick={() => props.onRemoveChildFromGuestList()}>{t(props.locale, "removechild")}</Button> : ''
                      : <Button style={{ width: '100%', marginBottom: '0.25rem' }} type="primary" onClick={() => props.onAddChildToGuestList(!props.onCanAddSingleGuest())}>{props.onCanAddSingleGuest() ? t(props.locale, "addchild") : t(props.locale, "swapparenttochild")}</Button> 
                    }
                  </React.Fragment>
                : ''                
                }
            <Button style={{ width: '100%' }} type="primary" onClick={() => props.onAddGuest()} disabled={props.onCanAddSingleGuest() ? false : true}>{props.onCanAddSingleGuest() ? t(props.locale, "addguest") : props.onBuildFullCapacityMessage()}</Button>
            {printNamesOfTheGuests()}
        </>
    );
}